<template>
    <div class="col-12 col-md-6 curated-album-col">
        <nuxt-link :to="`/contributor/${slug}/${album.slug}/${album.id}`" target="_blank">
            <div ref="wrap" class="curated-album-thumbnail contributor-album" :style="{ height: wrapHeight + 'px', 'background-image':`url(${album.thumbnail})` }">
                <div class="name">
                    {{ album.name }}
                </div>
            </div>
        </nuxt-link>
    </div>
</template>

<script>
export default {
    name: 'Album',
    props: {
        album: {},
        slug: null
    },
    data () {
        return {
            wrapHeight: null
        }
    },
    mounted () {
        this.$nextTick(function () {
            window.addEventListener('resize', this.setHeight)
            this.setHeight()
        })
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.setHeight)
    },
    methods: {
        setHeight () {
            this.wrapHeight = this.$refs.wrap.clientWidth * 0.58288
        }
    }
}
</script>
